import * as actionTypes from "./securityactionstypes";
import securityService from "../services/securityservice";
import * as appActions from "./appactions";
import sharedGlobals from "../sharedglobals";
import * as appConstants from "../overrides/appconstants";
import * as sharedConstants from "../constants/sharedContants";
export const setUserSession = (userSession) => {
  return {
    type: actionTypes.SET_USER_SESSION,
    payload: userSession,
  };
};
export const checkAccess = (checkAccessOptions) => {
  /*checkaccessoption{"
      {
        pageMenuId,
        additionalMenuIds=[],
        showLogin=true, 
        requireAllMenus=false
      }
  */
  return async function (dispatch, state) {
    let { pageMenuId, additionalMenuIds, showLogin, requireAllMenus } =
    {
      pageMenuId: null,
      additionalMenuIds: null,
      showLogin: true,
      requireAllMenus: null,
      ...checkAccessOptions
    };
    console.log('SSO checkAccess')
    let currentState = getState(state());
    let userSession = currentState.userSession;
    let isAuthenticated = userSession != null;
    sharedGlobals.sessionToken = securityService.getAuthToken();
    if (isAuthenticated === false && sharedGlobals.sessionToken != null) {
      try {
        let userSessionResult = await securityService.getUserSessionByToken();
        if (!userSessionResult.hasErrors) {
          isAuthenticated = true;
          userSession = userSessionResult.result.userSession;
          dispatch(setUserSession(userSession));
        }
      } catch (e) {
        //check exception for 401 , if not 401 throw exception
        if (!(e.status && e.status === 401)) {
          throw 'getUserssion failed';
        }
      }
    }
    let hasAccess = isAuthenticated;
    if (isAuthenticated && pageMenuId != null && pageMenuId !== '') {
      let menusToCheck = [pageMenuId];
      if (additionalMenuIds) {
        menusToCheck.push(...additionalMenuIds);
      }
      hasAccess = securityService.hasMenus(userSession.menus, menusToCheck, requireAllMenus);
    }
    //if system not sso redirect to sso
    if (!hasAccess && showLogin && appConstants.SYSTEM_ID !== 1) {
      console.log("redirecting");
      console.trace();
      window.location.href = sharedGlobals.appUrls.ssoUrl + 'login?pageId=' + pageMenuId;
    }
    return Promise.resolve(hasAccess);

  };
};
export const redirectToPage = (menuId) => {
  return async function (dispatch, state) {
    console.log('SSO redirectToPage')
    let currentState = getState(state());
    let systemurl = securityService.getSystemUrl(currentState.userSession.menus, menuId)
      + 'ssoredirecthandler?authToken=' + securityService.getAuthToken()
    if (menuId) {
      systemurl += '&pageId=' + menuId;
    }
    window.location.href = systemurl;
    //  window.location.href=securityService.getSystemUrl(currentState.userSession.menus, menuId)+menuId;
  }
};
export const handlessoRedirect = (pageId, authToken) => {
  return async function (dispatch, state) {
    console.log('SSO handlessoRedirect')
    securityService.setAuthCookie(authToken);
    if (!(await dispatch(checkAccess({ pageMenuId: pageId })))) {
      return Promise.resolve(null);
    }
    let currentState = getState(state());
    let url = '/dashboard';
    if (!(pageId == '' || pageId == null)) {
      let menu = currentState.userSession.menus.find(p => p.menuId == pageId);
      // if(menu.menuType==3){
      if (!(menu.url == null || menu.url == '')) {
        url ="/"+ menu.url;
      }
      // }  
      //   dispatch(securityActions.redirectToPage(pageMenuId));
    }
    return Promise.resolve(url);
  }
};
export const createUserSessionFromMicrosoftLogin = (token, userId) => {
  return async function (dispatch, state) {
    let sr = await securityService.createUserSessionFromMicrosoftLogin(token, userId);
    if (sr.hasErrors) {
      alert(sr.errors[0].errorMessage);
      return;
    }
    securityService.setAuthCookie(sr.result.sessionToken);
    dispatch(setUserSession(sr.result));
    let currentState = getState(state());
    let redirMenuId = localStorage.getItem('redirPageMenuId');
    if (redirMenuId) {
      localStorage.setItem('redirPageMenuId', '');
      let menu = currentState.userSession.menus.find(p => p.menuId == redirMenuId);
      if (!menu) {
        window.location.href = '/dashboard';
        return;
      }
      dispatch(redirectToPage(redirMenuId));
      return;
    }
    window.location.href = '/dashboard';
  }
};

export const getUserSession = () => {
  return async function (dispatch, state) {
    return state().securityReducer.userSession
  }
}
const getState = (state) => {
  return state.securityReducer;
};
